import React from 'react';

export const HiIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="18"
            height="18"
            viewBox="0 0 18 18"
        >
            <defs>
                <linearGradient
                    x1="0.2222222238779068"
                    y1="0"
                    x2="1"
                    y2="0.9166666865348816"
                    id="master_svg0_4765_25063"
                >
                    <stop offset="0%" stopColor="#0052FF" stopOpacity="1" />
                    <stop offset="100%" stopColor="#00A6FF" stopOpacity="1" />
                </linearGradient>
            </defs>
            <g>
                <path
                    d="M15.3958,2.67927L15.3508,2.63427C11.8431,-0.882589,6.15076,-0.873589,2.63411,2.63427C-0.882536,6.14213,-0.873537,11.8461,2.63411,15.3562C4.32382,17.055,6.6075,18,9.00143,18L15.7107,18C16.0887,18,16.4037,17.694,16.4037,17.307L16.4037,14.1141C16.8987,13.3941,17.2857,12.6201,17.5647,11.7921C18.5974,8.59021,17.7604,5.07335,15.3958,2.67927ZM8.22746,12.6201L8.77644,9.70624L6.24976,9.70624L5.69178,12.6201L4.20682,12.6201L5.52978,5.68312L7.01474,5.68312L6.49951,8.3922L9.03518,8.3922L9.55717,5.68537L11.0421,5.68537L9.71916,12.6201L8.22746,12.6201ZM12.5271,12.6201L11.0421,12.6201L12.0051,7.58217L13.4901,7.58217L12.5271,12.6201ZM13.5508,6.73615C13.3798,6.89815,13.1548,6.97916,12.9298,6.96116C12.5518,6.97916,12.2278,6.69115,12.2098,6.31314L12.2098,6.24113C12.2098,6.01613,12.2998,5.80012,12.4618,5.63811C12.6238,5.47611,12.8398,5.39511,13.0648,5.39511C13.4518,5.36811,13.7848,5.66511,13.8118,6.05213L13.8118,6.12413C13.8118,6.34914,13.7128,6.57414,13.5508,6.73615Z"
                    fill="url(#master_svg0_4765_25063)"
                    fillOpacity="1"
                />
            </g>
        </svg>
    );
};

export const OptIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="16"
            height="16"
            viewBox="0 0 16 16"
        >
            <defs>
                <linearGradient
                    x1="0.5"
                    y1="0"
                    x2="0.5"
                    y2="1"
                    id="master_svg0_4765_43680"
                >
                    <stop offset="0%" stopColor="#0052FF" stopOpacity="1" />
                    <stop
                        offset="100.00008344650269%"
                        stopColor="#00A6FF"
                        stopOpacity="1"
                    />
                </linearGradient>
            </defs>
            <g>
                <g>
                    <path
                        d="M10.8284,0.390625C11.5523,0.677083,12,1.14583,12,1.875C12,2.93757,11.4249,3.79941,10.5244,4.34679C13.7057,5.25766,16,7.89841,16,11.5C16,15,12.4183,16,8,16C3.58172,16,0,15,0,11.5C0,8.25774,2.35324,5.344,5.59778,4.35641C4.62748,3.7751,4,2.86155,4,1.875C4,1.14583,4.44772,0.677083,5.17157,0.390625C5.36256,0.315043,5.57281,0.373982,5.79912,0.437426C6.00167,0.49421,6.2171,0.554602,6.44312,0.525391C6.92167,0.463542,7.02588,0,8,0C8.97412,0,9.07833,0.463542,9.55688,0.525391C9.7829,0.554602,9.99833,0.49421,10.2009,0.437426C10.4272,0.373982,10.6374,0.315043,10.8284,0.390625Z"
                        fillRule="evenodd"
                        fill="url(#master_svg0_4765_43680)"
                        fillOpacity="1"
                    />
                </g>
                <g>
                    <path
                        d="M6.4763850000000005,6.609375C5.951199,6.609375,5.62224,7.17707,5.883389,7.632725L6.691995,9.043575L5.770816,9.043575C5.509066,9.043575,5.296875,9.255765,5.296875,9.517515C5.296875,9.779265,5.509066,9.991455,5.770816,9.991455L7.092285,9.991455L7.092445,10.838155L5.781786,10.838155C5.514089,10.838155,5.297060018,11.055135,5.296994209,11.322825C5.2969283763,11.590615,5.513996,11.807735000000001,5.781786,11.807735000000001L7.092285,11.807735000000001L7.092345,12.342395C7.092395,12.843665,7.498775,13.249995,8.000045,13.249995C8.501375,13.249995,8.907775,12.843575000000001,8.907745,12.342255L8.907715,11.807735000000001L10.218335,11.807735000000001C10.486075,11.807735000000001,10.703125,11.590685,10.703125,11.322945C10.703125,11.055205,10.486075,10.838155,10.218335,10.838155L8.907795,10.838155L8.908205,9.991455L10.229065,9.991455C10.490865,9.991455,10.703075,9.779195,10.703005000000001,9.517395C10.702935,9.255685,10.490765,9.043575,10.229065,9.043575L9.298465,9.043575L10.132465,7.598297C10.386125,7.158719,10.068875,6.609375,9.561365,6.609375C9.317285,6.609375,9.093175,6.744209,8.978825,6.959848L8.047075,8.717025L7.074195,6.96155C6.953755,6.744221,6.724855,6.609375,6.4763850000000005,6.609375"
                        fill="#BEF1FF"
                        fillOpacity="1"
                    />
                </g>
            </g>
        </svg>
    );
};

export const ActionIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="16.0001220703125"
            height="14"
            viewBox="0 0 16.0001220703125 14"
        >
            <defs>
                <linearGradient
                    x1="0"
                    y1="0.5"
                    x2="1.0312449932098389"
                    y2="0.5"
                    id="master_svg0_4765_43338"
                >
                    <stop offset="0%" stopColor="#0052FF" stopOpacity="1" />
                    <stop
                        offset="100.00001192092896%"
                        stopColor="#00A6FF"
                        stopOpacity="1"
                    />
                </linearGradient>
            </defs>
            <g>
                <g>
                    <path
                        d="M0.181426,12.4173C-0.273772,13.0789,0.179925,14,0.961054,14L11.1009,14C11.4301,14,11.7382,13.838,11.9247,13.5668L15.6406,8.16548C16.1199,7.4688,16.1199,6.5312,15.6406,5.83452L11.9247,0.433214C11.7382,0.162009,11.4301,0,11.1009,0L0.961054,0C0.179925,0,-0.273772,0.921064,0.181426,1.58274L3.90819,7L0.181426,12.4173Z"
                        fill="url(#master_svg0_4765_43338)"
                        fillOpacity="1"
                    />
                </g>
                <g>
                    <path
                        d="M10.706114770507813,6.86559483947754L9.087076770507812,9.14488483947754C8.841227770507812,9.490994839477539,8.933325770507812,9.972204839477538,9.289600770507812,10.203074839477539C9.627188770507813,10.421834839477539,10.077424770507813,10.333574839477539,10.307434770507813,10.00355483947754L12.095304770507813,7.438264839477539C12.328564770507812,7.103594839477539,12.335134770507812,6.660774839477539,12.111924770507812,6.3193148394775385L10.317874770507812,3.574891839477539C10.096054770507813,3.235567839477539,9.644144770507813,3.134972839477539,9.299337770507812,3.348164839477539C8.940404770507813,3.5700898394775393,8.836291770507813,4.044984839477539,9.069459770507812,4.396724839477539L10.706114770507813,6.86559483947754Z"
                        fillRule="evenodd"
                        fill="#BEF1FF"
                        fillOpacity="1"
                    />
                </g>
            </g>
        </svg>
    );
};

export const LeadIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="16"
            height="16"
            viewBox="0 0 16 16"
        >
            <defs>
                <linearGradient
                    x1="0.2222222238779068"
                    y1="0"
                    x2="1"
                    y2="0.9166666865348816"
                    id="master_svg0_4765_25063"
                >
                    <stop offset="0%" stopColor="#0052FF" stopOpacity="1" />
                    <stop offset="100%" stopColor="#00A6FF" stopOpacity="1" />
                </linearGradient>
            </defs>
            <g>
                <g>
                    <rect
                        x="0"
                        y="0"
                        width="16"
                        height="16"
                        rx="3"
                        fill="url(#master_svg0_4765_25063)"
                        fillOpacity="1"
                    />
                </g>
                <g transform="matrix(0.9510565400123596,0.30901700258255005,-0.30901700258255005,0.9510565400123596,1.041245425051045,-1.4164526592148263)">
                    <path
                        d="M12.4103975,8.516626468200684L12.3035575,8.516626468200684C11.6872675,8.516626468200684,11.1649575,8.914836468200683,10.9819475,9.466436468200683L7.653207500000001,9.420226468200685C7.2288274999999995,9.414326468200684,6.8895275,9.003326468200683,6.8964475,8.503846468200685L6.8974375000000006,8.413386468200684C6.9043575,7.917836468200684,7.2505875,7.518646468200684,7.6700175,7.518646468200684L7.6789275,7.518646468200684L11.149127499999999,7.566816468200684C11.707057500000001,7.573706468200683,12.2362875,7.3475564682006835,12.6319775,6.925746468200684C13.0118475,6.5216364682006835,13.2255175,5.984786468200683,13.2334275,5.412546468200683C13.2502475,4.2090664682006835,12.3431275,3.2169774682006835,11.2104575,3.2012454682006837L7.6185775,3.1520834682006837C7.3653375,2.8050014682006834,6.9548075,2.5788564682006836,6.4908675,2.5788564682006836L6.3840275,2.5788564682006836C5.6153995,2.5788564682006836,4.9921875,3.1982964682006836,4.9921875,3.9622764682006837L4.9921875,4.068456468200684C4.9921875,4.832436468200683,5.6153995,5.451876468200684,6.3840275,5.451876468200684L6.4908675,5.451876468200684C7.1328675,5.451876468200684,7.6729875,5.019256468200684,7.833247500000001,4.432256468200683L11.1936475,4.479456468200683C11.6180175,4.485356468200684,11.9573275,4.896346468200683,11.9504075,5.395836468200684C11.9464475,5.649506468200684,11.856427499999999,5.883516468200684,11.6941975,6.054596468200684C11.5487775,6.208966468200684,11.359837500000001,6.294506468200684,11.167927500000001,6.290576468200683L7.6977174999999995,6.241416468200684C6.5670375,6.224696468200683,5.6302385,7.191226468200684,5.6134215,8.394706468200685L5.6124325,8.485166468200685C5.5956155,9.688646468200684,6.5027375,10.679746468200683,7.6353975,10.696466468200684L11.1283575,10.745626468200683C11.3746775,11.132036468200683,11.8089475,11.389646468200684,12.3045475,11.389646468200684L12.4113775,11.389646468200684C13.1800075,11.389646468200684,13.8032275,10.770206468200684,13.8032275,10.006236468200683L13.8032275,9.900046468200683C13.8022375,9.135086468200683,13.1790175,8.516626468200684,12.4103975,8.516626468200684Z"
                        fill="#BEF1FF"
                        fillOpacity="1"
                    />
                </g>
            </g>
        </svg>
    );
};

export const Opt2Icon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="16"
            height="16.0001220703125"
            viewBox="0 0 16 16.0001220703125"
        >
            <defs>
                <linearGradient
                    x1="0.2222222238779068"
                    y1="0"
                    x2="1"
                    y2="0.9166666865348816"
                    id="master_svg0_4765_25063"
                >
                    <stop offset="0%" stopColor="#0052FF" stopOpacity="1" />
                    <stop offset="100%" stopColor="#00A6FF" stopOpacity="1" />
                </linearGradient>
            </defs>
            <g>
                <g>
                    <path
                        d="M3,0L11.2223,0C12.8792,0,14.2223,1.34315,14.2223,3L14.2223,4.78577Q13.4756,4.39856,12.6584,4.19928Q11.8412,4,11,4Q10.8282,4,10.6565,4.00843Q10.4849,4.01686,10.3139,4.03371Q10.1429,4.05055,9.97289,4.07576Q9.80291,4.10098,9.63437,4.1345Q9.46583,4.16803,9.29914,4.20978Q9.13245,4.25153,8.96801,4.30142Q8.80357,4.3513,8.64177,4.40919Q8.47997,4.46708,8.32121,4.53284Q8.16246,4.5986,8.00711,4.67207Q7.85177,4.74555,7.70022,4.82655Q7.54867,4.90756,7.40128,4.9959Q7.25389,5.08424,7.11101,5.17971Q6.96813,5.27518,6.8301,5.37755Q6.69208,5.47991,6.55925,5.58893Q6.42641,5.69794,6.29909,5.81334Q6.17176,5.92874,6.05025,6.05025Q5.92874,6.17176,5.81334,6.29909Q5.69794,6.42641,5.58893,6.55925Q5.47991,6.69208,5.37755,6.8301Q5.27518,6.96813,5.17971,7.11101Q5.08424,7.25389,4.9959,7.40128Q4.90756,7.54867,4.82655,7.70022Q4.74555,7.85177,4.67207,8.00711Q4.5986,8.16246,4.53284,8.32122Q4.46708,8.47997,4.40919,8.64177Q4.3513,8.80357,4.30142,8.96801Q4.25153,9.13245,4.20978,9.29914Q4.16803,9.46583,4.1345,9.63437Q4.10098,9.80291,4.07576,9.97289Q4.05055,10.1429,4.03371,10.3139Q4.01686,10.4849,4.00843,10.6565Q4,10.8282,4,11Q4,11.3484,4.03459,11.695Q4.06918,12.0417,4.13802,12.3832Q4.20685,12.7247,4.30926,13.0577Q4.41166,13.3906,4.54662,13.7118Q4.68158,14.033,4.84776,14.3392Q5.01395,14.6453,5.20971,14.9335Q5.40547,15.2217,5.62888,15.489Q5.85228,15.7563,6.10112,16.0001L3,16.0001C1.34315,16.0001,0,14.657,0,13.0001L0,3C0,1.34315,1.34315,0,3,0ZM11,16Q11.1227,16,11.2453,15.994Q11.3679,15.988,11.4901,15.9759Q11.6122,15.9639,11.7337,15.9459Q11.8551,15.9279,11.9754,15.9039Q12.0958,15.88,12.2149,15.8502Q12.334,15.8203,12.4514,15.7847Q12.5689,15.7491,12.6844,15.7077Q12.8,15.6664,12.9134,15.6194Q13.0268,15.5724,13.1378,15.5199Q13.2487,15.4675,13.357,15.4096Q13.4652,15.3517,13.5705,15.2886Q13.6758,15.2255,13.7779,15.1573Q13.8799,15.0892,13.9785,15.016Q14.0771,14.9429,14.172,14.8651Q14.2668,14.7872,14.3578,14.7048Q14.4487,14.6223,14.5355,14.5355Q14.6223,14.4487,14.7048,14.3578Q14.7872,14.2668,14.8651,14.172Q14.9429,14.0771,15.016,13.9785Q15.0892,13.8799,15.1573,13.7779Q15.2255,13.6758,15.2886,13.5705Q15.3517,13.4652,15.4096,13.357Q15.4675,13.2487,15.5199,13.1378Q15.5724,13.0268,15.6194,12.9134Q15.6664,12.8,15.7077,12.6844Q15.7491,12.5689,15.7847,12.4514Q15.8203,12.334,15.8502,12.2149Q15.88,12.0958,15.9039,11.9755Q15.9279,11.8551,15.9459,11.7337Q15.9639,11.6122,15.9759,11.4901Q15.988,11.3679,15.994,11.2453Q16,11.1227,16,11Q16,10.8773,15.994,10.7547Q15.988,10.6321,15.9759,10.5099Q15.9639,10.3878,15.9459,10.2663Q15.9279,10.1449,15.9039,10.0245Q15.88,9.90416,15.8502,9.7851Q15.8203,9.66603,15.7847,9.54858Q15.7491,9.43112,15.7077,9.31555Q15.6664,9.19998,15.6194,9.08658Q15.5724,8.97318,15.5199,8.86222Q15.4675,8.75126,15.4096,8.64302Q15.3517,8.53477,15.2886,8.42948Q15.2255,8.3242,15.1573,8.22215Q15.0892,8.12009,15.016,8.0215Q14.9429,7.92291,14.8651,7.82803Q14.7872,7.73315,14.7048,7.6422Q14.6223,7.55126,14.5355,7.46447Q14.4487,7.37767,14.3578,7.29524Q14.2668,7.21281,14.172,7.13495Q14.0771,7.05708,13.9785,6.98396Q13.8799,6.91084,13.7779,6.84265Q13.6758,6.77446,13.5705,6.71136Q13.4652,6.64825,13.357,6.59039Q13.2487,6.53253,13.1378,6.48005Q13.0268,6.42757,12.9134,6.3806Q12.8,6.33363,12.6844,6.29228Q12.5689,6.25093,12.4514,6.2153Q12.334,6.17967,12.2149,6.14984Q12.0958,6.12002,11.9755,6.09607Q11.8551,6.07213,11.7337,6.05412Q11.6122,6.03611,11.4901,6.02408Q11.3679,6.01205,11.2453,6.00602Q11.1227,6,11,6Q10.8773,6,10.7547,6.00602Q10.6321,6.01205,10.5099,6.02408Q10.3878,6.03611,10.2663,6.05412Q10.1449,6.07213,10.0245,6.09607Q9.90416,6.12002,9.7851,6.14984Q9.66603,6.17967,9.54858,6.2153Q9.43112,6.25093,9.31555,6.29228Q9.19998,6.33363,9.08658,6.3806Q8.97318,6.42757,8.86222,6.48005Q8.75126,6.53253,8.64302,6.59039Q8.53477,6.64825,8.42948,6.71136Q8.3242,6.77446,8.22215,6.84265Q8.12009,6.91084,8.0215,6.98396Q7.92291,7.05708,7.82803,7.13495Q7.73315,7.21281,7.6422,7.29524Q7.55126,7.37767,7.46447,7.46447Q7.37767,7.55126,7.29524,7.6422Q7.21281,7.73315,7.13495,7.82803Q7.05708,7.92291,6.98396,8.0215Q6.91084,8.12009,6.84265,8.22215Q6.77446,8.3242,6.71136,8.42948Q6.64825,8.53477,6.59039,8.64302Q6.53253,8.75126,6.48005,8.86222Q6.42757,8.97318,6.3806,9.08658Q6.33363,9.19998,6.29228,9.31555Q6.25093,9.43112,6.2153,9.54858Q6.17967,9.66603,6.14984,9.7851Q6.12002,9.90416,6.09607,10.0245Q6.07213,10.1449,6.05412,10.2663Q6.03611,10.3878,6.02408,10.5099Q6.01204,10.6321,6.00602,10.7547Q6,10.8773,6,11Q6,11.1227,6.00602,11.2453Q6.01204,11.3679,6.02408,11.4901Q6.03611,11.6122,6.05412,11.7337Q6.07213,11.8551,6.09607,11.9754Q6.12002,12.0958,6.14984,12.2149Q6.17967,12.334,6.2153,12.4514Q6.25093,12.5689,6.29228,12.6844Q6.33363,12.8,6.3806,12.9134Q6.42757,13.0268,6.48005,13.1378Q6.53253,13.2487,6.59039,13.357Q6.64825,13.4652,6.71136,13.5705Q6.77446,13.6758,6.84265,13.7779Q6.91084,13.8799,6.98396,13.9785Q7.05708,14.0771,7.13495,14.172Q7.21281,14.2668,7.29524,14.3578Q7.37767,14.4487,7.46447,14.5355Q7.55126,14.6223,7.6422,14.7048Q7.73315,14.7872,7.82803,14.8651Q7.92291,14.9429,8.0215,15.016Q8.12009,15.0892,8.22215,15.1573Q8.3242,15.2255,8.42948,15.2886Q8.53477,15.3517,8.64302,15.4096Q8.75126,15.4675,8.86222,15.5199Q8.97318,15.5724,9.08658,15.6194Q9.19998,15.6664,9.31555,15.7077Q9.43112,15.7491,9.54858,15.7847Q9.66603,15.8203,9.7851,15.8502Q9.90416,15.88,10.0245,15.9039Q10.1449,15.9279,10.2663,15.9459Q10.3878,15.9639,10.5099,15.9759Q10.6321,15.988,10.7547,15.994Q10.8773,16,11,16Z"
                        fillRule="evenodd"
                        fill="url(#master_svg0_4765_25063)"
                        fillOpacity="1"
                    />
                </g>
                <g>
                    <rect
                        x="10.25"
                        y="8"
                        width="1.5"
                        height="3.765625"
                        rx="0.75"
                        fill="#BEF1FF"
                        fillOpacity="1"
                    />
                </g>
                <g>
                    <ellipse
                        cx="11"
                        cy="13.375"
                        rx="0.90625"
                        ry="0.90625"
                        fill="#BEF1FF"
                        fillOpacity="1"
                    />
                </g>
            </g>
        </svg>
    );
};

export const CusIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="16"
            height="16"
            viewBox="0 0 16 16"
        >
            <defs>
                <linearGradient
                    x1="0.2222222238779068"
                    y1="0"
                    x2="1"
                    y2="0.9166666865348816"
                    id="master_svg0_4765_25063"
                >
                    <stop offset="0%" stopColor="#0052FF" stopOpacity="1" />
                    <stop offset="100%" stopColor="#00A6FF" stopOpacity="1" />
                </linearGradient>
            </defs>
            <g>
                <g>
                    <path
                        d="M8.88379,16L2.98229,16C1.32543,16,0,14.6569,0,13L0,3C0,1.34315,1.34315,0,3,0L10.3333,0C11.9901,0,13.3333,1.32456,13.3333,2.9814Q13.3333,5.54443,13.3333,7.09308C13.2374,7.08413,13.1397,7.07697,13.0401,7.07697C10.7381,7.07697,9.87267,8.31477,9.87267,9.77778C9.87267,10.4833,10.3786,11.294,10.6667,11.6168C10.6531,11.8422,10.6716,12.0093,10.6843,12.1237C10.697,12.2381,10.7038,12.2997,10.6667,12.3141C9.79781,12.3141,8.88379,13.4182,8.88379,14.2777Q8.76613,15.7797,8.88379,16ZM15.0978,13.6152L15.2416,13.6152C15.3404,13.6152,15.4339,13.6349,15.522,13.6706C15.8006,13.7832,16.0001,14.0532,16.0001,14.3696L16.0001,15.2456C16.0001,15.6621,15.6586,16,15.2416,16L10.5363,16C10.1175,16,9.77783,15.6621,9.77783,15.2456L9.77783,14.3696C9.77783,13.9531,10.1175,13.6152,10.5363,13.6152L10.6855,13.6152C10.9353,13.5526,11.1456,13.4364,11.3109,13.2505C11.7908,12.716,11.8321,11.8025,11.8196,11.3466C11.3469,11.0123,11.0341,10.4653,11.0341,9.84492C11.0341,8.82771,11.8663,8,12.8889,8C13.9116,8,14.7437,8.82771,14.7437,9.84492C14.7437,10.4653,14.431,11.0123,13.9583,11.3466C13.9475,11.8025,13.9907,12.716,14.4706,13.2505C14.6377,13.4364,14.848,13.5526,15.0978,13.6152Z"
                        fillRule="evenodd"
                        fill="url(#master_svg0_4765_25063)"
                        fillOpacity="1"
                    />
                </g>
                <g>
                    <path
                        d="M2.7824163418139647,4.444242461791992C2.7824163418139647,4.9348464617919925,3.1412376718139647,5.333156461791992,3.5831976718139646,5.333156461791992L9.759467671813965,5.333156461791992C10.201427671813965,5.333156461791992,10.560247671813965,4.9348464617919925,10.560247671813965,4.444242461791992C10.560247671813965,3.953639461791992,10.201427671813965,3.555326461791992,9.759467671813965,3.555326461791992L3.5831976718139646,3.555326461791992C3.1412376718139647,3.555326461791992,2.7824163418139647,3.953639461791992,2.7824163418139647,4.444242461791992ZM3.648871671813965,8.888946461791992L7.279487671813965,8.888946461791992C7.6256176718139645,8.888946461791992,8.111027671813964,8.490636461791993,8.111027671813964,8.000026461791993C8.111027671813964,7.509426461791993,7.6256176718139645,7.111116461791992,7.279487671813965,7.111116461791992L3.648871671813965,7.111116461791992C3.302744671813965,7.111116461791992,2.777777671813965,7.509426461791993,2.777777671813965,8.000026461791993C2.777777671813965,8.490636461791993,3.302744671813965,8.888946461791992,3.648871671813965,8.888946461791992Z"
                        fillRule="evenodd"
                        fill="#BEF1FF"
                        fillOpacity="1"
                    />
                </g>
            </g>
        </svg>
    );
};

export const AchieveIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="16"
            height="16"
            viewBox="0 0 16 16"
        >
            <defs>
                <linearGradient
                    x1="0"
                    y1="0.5"
                    x2="1"
                    y2="0.5"
                    id="master_svg0_4765_42698"
                >
                    <stop offset="0%" stopColor="#0052FF" stopOpacity="1" />
                    <stop offset="100%" stopColor="#00D4FF" stopOpacity="1" />
                </linearGradient>
            </defs>
            <g>
                <g>
                    <path
                        d="M0,1L0,15Q0,15.0985,0.0192147,15.1951Q0.0384294,15.2917,0.0761205,15.3827Q0.113811,15.4737,0.16853,15.5556Q0.223249,15.6375,0.292893,15.7071Q0.362537,15.7767,0.44443,15.8315Q0.526322,15.8862,0.617316,15.9239Q0.708311,15.9616,0.80491,15.9808Q0.901509,16,1,16Q1.09849,16,1.19509,15.9808Q1.29169,15.9616,1.38268,15.9239Q1.47368,15.8862,1.55557,15.8315Q1.63746,15.7767,1.70711,15.7071Q1.77675,15.6375,1.83147,15.5556Q1.88619,15.4737,1.92388,15.3827Q1.96157,15.2917,1.98079,15.1951Q2,15.0985,2,15L2,12L14.9472,12C15.7452,12,16.2523,11.1875,15.8701,10.5211L13.5643,6.5L15.8701,2.47885C16.2523,1.81248,15.7452,1,14.9472,1L2,1Q2,0.901509,1.98079,0.80491Q1.96157,0.708311,1.92388,0.617316Q1.88619,0.526322,1.83147,0.44443Q1.77675,0.362537,1.70711,0.292893Q1.63746,0.223249,1.55557,0.16853Q1.47368,0.113811,1.38268,0.0761205Q1.29169,0.0384294,1.19509,0.0192147Q1.09849,0,1,0Q0.901509,0,0.80491,0.0192147Q0.708311,0.0384294,0.617316,0.0761205Q0.526322,0.113811,0.44443,0.16853Q0.362537,0.223249,0.292893,0.292893Q0.223249,0.362537,0.16853,0.44443Q0.113811,0.526322,0.0761205,0.617316Q0.0384294,0.708311,0.0192147,0.80491Q0,0.901509,0,1Z"
                        fillRule="evenodd"
                        fill="url(#master_svg0_4765_42698)"
                        fillOpacity="1"
                    />
                </g>
                <g>
                    <path
                        d="M7.56145875,8.707056464843749L10.81482875,5.45366646484375C11.124168749999999,5.14433646484375,11.124168749999999,4.64281146484375,10.81482875,4.33347846484375C10.505498750000001,4.02414246484375,10.00396875,4.02414246484375,9.69463875,4.33347846484375L6.85434875,7.173776464843749L5.59825875,5.917676464843749C5.28892875,5.60834646484375,4.78739575,5.60834646484375,4.47806175,5.917676464843749C4.16873075,6.22700646484375,4.16873075,6.728536464843749,4.47806275,7.03786646484375L6.14723875,8.707056464843749C6.53776875,9.09758646484375,7.1709387499999995,9.09758646484375,7.56145875,8.707056464843749"
                        fillRule="evenodd"
                        fill="#BEF1FF"
                        fillOpacity="1"
                    />
                </g>
            </g>
        </svg>
    );
};

export const MoneyIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="12"
            height="12"
            viewBox="0 0 12 12"
        >
            <g>
                <g>
                    <ellipse
                        cx="6"
                        cy="6"
                        rx="6"
                        ry="6"
                        fill="#FFCC00"
                        fillOpacity="1"
                    />
                </g>
                <g>
                    <path
                        d="M4.879025,2.859375L3.296875,2.859375L4.691995,5.293575000000001L3.296875,5.293575000000001L3.296875,6.241455L5.092285,6.241455L5.092445,7.088155L3.297113359,7.088155L3.296875,8.057735000000001L5.092285,8.057735000000001L5.092445,9.499995L6.907795,9.499995L6.907715,8.057735000000001L8.703125,8.057735000000001L8.703125,7.088155L6.907795,7.088155L6.908205000000001,6.241455L8.703125,6.241455L8.702885,5.293575000000001L7.298465,5.293575000000001L8.703125,2.859375L7.164664999999999,2.859375L6.0470749999999995,4.967025L4.879025,2.859375Z"
                        fill="#FFFFFF"
                        fillOpacity="1"
                    />
                </g>
            </g>
        </svg>
    );
};
